import script from "./TopMenuElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopMenuElement.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__